// extracted by mini-css-extract-plugin
module.exports = {"page-title":"CreateRequestFromPortalView_page-title__8EB39","form-footer":"CreateRequestFromPortalView_form-footer__2rG56"};